import { addDbItem, getDbItem, deleteIndexedDB, deleteRecordsByUserId } from "../utils/idb-util"
import { getStorageKey, createStorageKey } from "../services/storageKey"

function getRefId(obj) {
    if (!obj) return

    if (typeof obj === "string") return obj

    if (!obj.ref && obj._id) return obj._id

    if (obj.ref && typeof obj.ref === "string") return obj.ref

    if (obj.ref && obj.ref._id) return obj.ref._id
}

const deleteAllStorage = async ({ orgData, meInOrg }) => {
    if (!meInOrg?._id || !orgData._id) {
        return
    }
    const storeId = `${meInOrg._id}-${orgData._id}`
    try {
        await deleteRecordsByUserId("orgMissionDb", "store", storeId)
    } catch (e) {}
    try {
        await deleteRecordsByUserId("orgPlanItemDb", "store", storeId)
    } catch (e) {}
    try {
        await deleteRecordsByUserId("orgActionDb", "store", storeId)
    } catch (e) {}
    try {
        await deleteRecordsByUserId("orgActionItemDb", "store", storeId)
    } catch (e) {}
    try {
        await deleteIndexedDB("orgLeavesDb")
    } catch (e) {}
    try {
        await deleteIndexedDB("timesheetMissionDb")
    } catch (e) {}
    try {
        await deleteIndexedDB("timesheetOrgDb")
    } catch (e) {}
    try {
        await deleteIndexedDB("timesheetMissionFullDb")
    } catch (e) {}
    try {
        await deleteIndexedDB("timesheetOrgFullDb")
    } catch (e) {}
    try {
        await deleteRecordsByUserId("orgActionItemDb", "store", storeId)
    } catch (e) {}
    try {
        await deleteRecordsByUserId("orgClientsFullDb", "store", storeId)
    } catch (e) {}
    try {
        await deleteIndexedDB("orgFinancialsDb")
    } catch (e) {}
    try {
        await deleteIndexedDB("approvedTimesheetsDB")
    } catch (e) {}
    try {
        await deleteIndexedDB("pmLeaves")
    } catch (e) {}
    try {
        await deleteIndexedDB("pmTimesheets")
    } catch (e) {}

    return true
}

export const getEncryptionKey = async ({ orgData, meInOrg, app }) => {
    try {
        const me = meInOrg || orgData?.people?.find((p) => getRefId(p) === app.state.person._id)

        if (!orgData?._id || !me?._id) {
            throw new Error("Missing organization or user data")
        }

        const keyStoreId = `${orgData._id}-${me._id}`

        // Attempt to get existing key with retry logic for race conditions
        let attempts = 0
        while (attempts < 3) {
            try {
                const existing = await getDbItem("secureKeys", "store", keyStoreId)

                if (existing?.data) {
                    const res = await getStorageKey(existing.data)
                    if (res?.key) {
                        return res.key
                    }
                }

                //Rebuild all
                await deleteAllStorage({ orgData, meInOrg })

                // Create new key if none exists
                const newKey = await createStorageKey(orgData._id)

                await addDbItem("secureKeys", "store", {
                    id: keyStoreId,
                    data: newKey.keyId,
                })

                return newKey.key
            } catch (err) {
                if (err.status === 410) {
                    if (deleteAllStorage) {
                        await deleteAllStorage({ orgData, meInOrg })
                    }
                    // Continue to next iteration to recreate
                } else if (attempts === 2) {
                    throw err
                }
            }
            attempts++
        }
    } catch (error) {
        console.error("Key holder failed:", error)
        throw new Error(`Key management failed: ${error.message}`)
    }
}
